module.exports = __webpack_public_path__ + "static/media/StatsIcon.b61bcbdf.svg";